import { FC } from 'react';

import Table from 'modules/_shared/Table';

import TradingOfferOperationsTableHeader from './TradingOfferOperationsTableHeader';
import TradingOfferOperationsTableBody from './TradingOfferOperationsTableBody';

const TradingOfferOperationsTable: FC = () => {
  const tableContent = (
    <>
      <TradingOfferOperationsTableHeader />
      <TradingOfferOperationsTableBody />
    </>
  );

  return <Table content={tableContent} scrollHorizontal />;
};

export default TradingOfferOperationsTable;
